import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { 
    Container, Typography, Box, Tabs, Tab, Skeleton, Button, Pagination, Stack 
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

// Controller & Components
import { getMyBookings } from '../../../controllers/customer/BookingController';
import BookingCard from './BookingCard';
import CustomBreadcrumbs from '../../../components/breadcrumbs';

export default function ClientReservationsPage() {
    const history = useHistory();
    const { t } = useTranslation();

    const [loading, setLoading] = useState(true);
    const [bookings, setBookings] = useState([]);
    
    const [activeTab, setActiveTab] = useState('upcoming'); // 'upcoming' | 'history'
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        loadBookings();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab, page]);

    const loadBookings = async () => {
        setLoading(true);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        
        const res = await getMyBookings(activeTab, page);
        if (res.success) {
            setBookings(res.data);
            if (res.meta) setTotalPages(res.meta.last_page);
        }
        setLoading(false);
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        setPage(1);
    };

    const handleCancelBooking = (booking) => {
        if(window.confirm(t('bookings.cancel_confirm'))) {
            alert("Cancel logic here (TODO for next step)");
            // Aquí llamarías a api.post('/bookings/cancel', { id: booking.id })
        }
    };

    return (
        <Container maxWidth="xl" sx={{ pb: 8 }}>
            <CustomBreadcrumbs 
                returnTo='/profile' 
                crumbs={[{ name: t('helpers.profile'), link: '/profile' }, { name: t('bookings.title'), link: '/reservations' }]} 
            />
            
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} mt={2}>
                <Typography variant="h4" fontWeight="bold">{t('bookings.title')}</Typography>
                <Button 
                    variant="contained" 
                    startIcon={<FontAwesomeIcon icon={faPlus}/>} 
                    onClick={() => history.push('/')} 
                    sx={{ borderRadius: 50, px: 3 }}
                >
                    {t('bookings.new_btn')}
                </Button>
            </Box>

            {/* TABS */}
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <Tabs value={activeTab} onChange={handleTabChange} variant="fullWidth">
                    <Tab label={t('bookings.tabs.upcoming')} value="upcoming" sx={{ fontWeight: 'bold' }} />
                    <Tab label={t('bookings.tabs.history')} value="history" sx={{ fontWeight: 'bold' }} />
                </Tabs>
            </Box>

            {/* LISTA */}
            {loading ? (
                <Stack spacing={2}>
                    {[1, 2, 3].map((i) => <Skeleton key={i} variant="rectangular" height={120} sx={{ borderRadius: 3 }} />)}
                </Stack>
            ) : bookings.length === 0 ? (
                <Box textAlign="center" py={8} bgcolor="#f9fafb" borderRadius={4} border="1px dashed #ddd">
                    <FontAwesomeIcon icon={faCalendarAlt} size="3x" color="#ccc" />
                    <Typography variant="h6" color="text.secondary" mt={2}>
                        {t('bookings.empty')}
                    </Typography>
                </Box>
            ) : (
                <Stack spacing={2}>
                    {bookings.map((booking) => (
                        <BookingCard 
                            key={booking.uuid} 
                            booking={booking} 
                            onCancel={handleCancelBooking} 
                        />
                    ))}
                </Stack>
            )}

            {/* PAGINATION */}
            {!loading && bookings.length > 0 && (
                <Box display="flex" justifyContent="center" mt={4}>
                    <Pagination 
                        count={totalPages} page={page} onChange={(e, v) => setPage(v)} 
                        color="primary" shape="rounded"
                    />
                </Box>
            )}
        </Container>
    );
}